import Phaser from 'phaser';
import { CONFIG } from '../config.js';
import {
  generatePlaceholderTextures,
  KENNEY_SPRITES,
} from '../systems/PlaceholderTextures.js';

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'PreloadScene' });
  }

  preload() {
    // Try to load every Kenney sprite. If any fails, the placeholder for that
    // key will be generated in create(), so the game keeps working.
    for (const [key, path] of Object.entries(KENNEY_SPRITES)) {
      this.load.image(key, path);
    }
    this.load.image('pixie-logo', 'assets/branding/pixie_logo_horizontal.png');

    // Swallow load errors silently — we have programmatic fallbacks.
    this.load.on('loaderror', (file) => {
      console.warn('[PreloadScene] failed to load', file.key, '— using placeholder');
    });

    // Tiny progress bar
    const { width, height } = this.scale;
    const barW = 200;
    const barH = 6;
    const barX = (width - barW) / 2;
    const barY = height / 2 + 30;
    const bg = this.add.rectangle(barX, barY, barW, barH, 0x312e81).setOrigin(0, 0);
    const bar = this.add.rectangle(barX, barY, 0, barH, 0xd946ef).setOrigin(0, 0);
    this.add
      .text(width / 2, height / 2 - 10, 'LOADING...', {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '16px',
        color: '#d946ef',
      })
      .setOrigin(0.5);
    this.load.on('progress', (p) => {
      bar.width = barW * p;
    });
  }

  create() {
    // Fill in any missing textures with placeholders.
    generatePlaceholderTextures(this);

    // Wait for the web font, then go to the splash.
    const proceed = () => {
      this.time.delayedCall(120, () => this.scene.start('SplashScene'));
    };
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(proceed);
    } else {
      this.time.delayedCall(450, proceed);
    }
  }
}
